import { CheckCircle24, Circle24, CircleFilled24 } from '@vinted/monochrome-icons'
import { Icon } from '@vinted/web-ui'

enum Status {
  Active,
  Completed,
  Inactive,
}

type Props = {
  status?: Status
  stepNumber?: number
}

const ProgressStepIconExperimental = ({ status, stepNumber }: Props) => {
  if (status === Status.Completed)
    return <Icon name={CheckCircle24} color="primary-default" aria={{ 'aria-hidden': true }} />

  if (status === Status.Active)
    return (
      <div className="u-position-relative u-flexbox u-justify-content-center u-align-items-center">
        <Icon name={CircleFilled24} color="primary-default" aria={{ 'aria-hidden': true }} />
        <div className="progress-step-icon__number progress-step-icon__number--filled u-position-absolute">
          {stepNumber}
        </div>
      </div>
    )

  return (
    <div className="u-position-relative u-flexbox u-justify-content-center u-align-items-center">
      <Icon name={Circle24} color="greyscale-level-4" aria={{ 'aria-hidden': true }} />
      <div className="progress-step-icon__number u-position-absolute">{stepNumber}</div>
    </div>
  )
}

export default Object.assign(ProgressStepIconExperimental, { Status })
